import { Injectable, TemplateRef } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { ModalRef } from '@frontend/sports/modal/feature';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { DeviceService } from '@frontend/vanilla/core';

import { PopupManager } from '../../popup/popup-manager.service';
import { BetBuilderTrackingValues } from '../bet-builder-tracking';
import { BetBuilderEventModel } from '../model/bet-builder-event-model';

export interface BetBuilderOverlayOption {
    headerTemplate: TemplateRef<any>;
    event: EventModel | BetBuilderEventModel;
    source?: string;
    isOverlay?: boolean;
}
@Injectable({ providedIn: 'root' })
export class BetBuilderOverlayService {
    readonly BET_BUILDER_OVERLAY = 'bet-builder-overlay';

    private exitConfirmationModalDialogRef: Nullable<ModalRef>;

    constructor(
        private popupManager: PopupManager,
        private device: DeviceService,
        private tracker: TrackingService,
        private epcotConfig: EpcotConfig,
    ) {}

    async openBuilder(option: BetBuilderOverlayOption): Promise<void> {
        const epcotClass = this.epcotConfig.isEnabled ? 'epcot-enabled' : '';

        this.popupManager.open(this.BET_BUILDER_OVERLAY, undefined, {
            data: {
                eventData: option.event,
                source: option.source,
                isOverlay: option.isOverlay,
            },
            settings: {
                isPopup: this.device.isMobile,
                cssClass: this.device.isMobile
                    ? `modal-popup betbuilder-overlay quick-bet-module ${epcotClass}`
                    : `betbuilder-overlay modal-fit modal-dialog-wrapper quick-bet-module ${epcotClass}`,
                headerTemplate: option.headerTemplate,
                headerSelector: 'ms-betbuilder-overlay-header',
                scrollTargetQuerySelector: '.ng-scroll-viewport',
                gestures: true,
            },
        });
    }

    close(trackingValues?: { sportId: number; leagueId: number; eventName: string }): void {
        if (trackingValues) {
            this.trackCloseBuilder(trackingValues.sportId, trackingValues.leagueId, trackingValues.eventName);
        }

        this.dismissConfirmationScreen();

        this.popupManager.toggle(this.BET_BUILDER_OVERLAY);
    }

    dismissConfirmationScreen(): void {
        if (this.exitConfirmationModalDialogRef) {
            this.exitConfirmationModalDialogRef.close();
            this.exitConfirmationModalDialogRef = null;
        }
    }

    trackCloseBuilder(sportId: number, leagueId: number, eventName: string) {
        this.tracker.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetBuilderTrackingValues.BetBuilder,
            [trackingConstants.COMPONENT_LABEL_EVENT]: BetBuilderTrackingValues.BuildaBetPod,
            [trackingConstants.COMPONENT_ACTION_EVENT]: BetBuilderTrackingValues.Click,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: eventName,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: BetBuilderTrackingValues.Close,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.SPORT_ID]: sportId.toString(),
            [trackingConstants.SPORT_LEAGUE_ID]: leagueId.toString(),
        });
    }
}
